import {Link} from "react-router-dom";
import {useContext} from "react";
import AppContext from "../../../context";

const Header = () => {
    const context = useContext(AppContext);
    const isHybrid = context.domain?.businessType === 'hybrid' || context.domain?.businessType === 'hybrid-new';
    const homePath = isHybrid ? '/classes' : '/';
    const contactPath = isHybrid ? '/classes/contact' : '/contact';
    const createAccountPath = isHybrid ? '/entry/create-account' : '/create-account';
    const loginPath = isHybrid ? '/entry/login' : '/login';
    const accountPath = isHybrid ? '/dashboard/settings' : '/account';

    return <div className={"border-b border-borderGrey p-4 flex justify-between items-center"}>
        <Link to={homePath} className={"flex items-center gap-2 h-10"}>
            {context.domain.logo ? <div className={'flex w-14 h-10 items-center justify-center overflow-visible'}>
                <img src={context.domain.logo} alt={context.domain.name} className={"max-w-full max-h-full object-contain"}/>
            </div> : null }
            <p>{context.domain.name}</p>
        </Link>
        <div className={"flex items-center gap-4"}>
            {context.domain.contactEmail || context.domain.contactPhone ? <Link to={contactPath}>Contact</Link> : null}
            {!context.user ?
                <>
                    <Link to={createAccountPath} className={"border border-borderGrey px-3 py-1 rounded"}>Create Account</Link>
                    <Link to={loginPath} className={"border border-borderGrey px-3 py-1 rounded"}>Log In</Link>
                </>
                : context.user.admin ?
                    <Link to={"/admin"} className={"border border-borderGrey px-3 py-1 rounded"}>Admin Dashboard</Link>
                    :
                    <Link to={accountPath} className={"border border-borderGrey px-3 py-1 rounded"}>My Account</Link>
            }
        </div>
    </div>
}

export default Header
